var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { SideArrow } from "sb-resp-ui";
import { observer } from "mobx-react";
let SuperBannerArrows = class SuperBannerArrows extends React.PureComponent {
    render() {
        const { scrollable, onClick } = this.props;
        return (React.createElement(React.Fragment, null,
            scrollable.left && React.createElement(SideArrow, { type: "left", onClick: () => onClick("Left"), dataUat: "superbanner-arrow-left" }),
            scrollable.right && React.createElement(SideArrow, { type: "right", onClick: () => onClick("Right"), dataUat: "superbanner-arrow-right" })));
    }
};
SuperBannerArrows = __decorate([
    observer
], SuperBannerArrows);
export { SuperBannerArrows };
//# sourceMappingURL=SuperBannerArrows.js.map